import { faSquareGithub, faLinkedin, faSquareInstagram } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

export const contactInfo = [
    {
        platform: 'GitHub',
        name: 'github.com/jgchoti',
        link: "https://github.com/jgchoti",
        title: "Visit Choti's GitHub profile",
        icon: faSquareGithub
    },
    {
        platform: 'Linkedin',
        name: 'linkedin.com/in/chotirat',
        link: "https://www.linkedin.com/in/chotirat/",
        title: "Visit Choti's LinkedIn profile",
        icon: faLinkedin
    }, {
        platform: 'Instagram',
        name: '@jgchoti',
        link: "https://www.instagram.com/jgchoti/",
        title: "Visit Choti's Instagram profile",
        icon: faSquareInstagram
    }
    , {
        platform: 'E-mail',
        name: 'jgchotirat@gmail.com',
        link: "mailto:jgchotirat@gmail.com",
        title: "Choti's E-mail",
        icon: faEnvelope
    }
]

